<template>
  <v-container fluid>
    <v-card class="mx-auto experience">
      <v-card-title class="d-flex justify-space-between">
        <v-btn
          class="workexp--button"
          text
          color="error"
          @click="$router.back()"
        >
          <v-icon class="mx-2"> arrow_back </v-icon>
          back
        </v-btn>
      </v-card-title>
      <v-card-text>
        <div><p>Job Position Details</p></div>
        <v-form v-model="isValid" ref="workExpForm">
          <v-row>
            <v-col cols="12" md="4">
              <v-text-field
                placeholder="Enter Name of Firm"
                label="Company"
                v-model="formData.nameOfFirm"
                :rules="[rules.required]"
                persistent-placeholder
                dense
                color="primary"
                outlined
                prepend-inner-icon="apartment"
                clearable
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="4">
              <v-text-field
                placeholder="Enter Position Held"
                label="Role"
                v-model="formData.positionHeld"
                :rules="[rules.required]"
                dense
                persistent-placeholder
                color="primary"
                outlined
                prepend-inner-icon="badge"
                clearable
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="4">
              <v-select
                placeholder="Enter sector"
                label="Sector"
                persistent-placeholder
                v-model="formData.sector"
                :rules="[rules.required]"
                :items="industryGroup"
                item-text="description"
                item-value="code"
                dense
                color="primary"
                outlined
                prepend-inner-icon="work_outline"
                clearable
              />
            </v-col>
            <v-col cols="12" :md="current ? '6' : '4'" sm="12" xs="12">
              <v-text-field
                placeholder="Enter From Date"
                label="From Date"
                v-model="formData.fromDate"
                persistent-placeholder
                :rules="[rules.required]"
                type="date"
                dense
                color="primary"
                outlined
                prepend-inner-icon="today"
                clearable
              ></v-text-field>
            </v-col>
            <v-col cols="12" :md="current ? '6' : '4'" sm="12" xs="12">
              <v-switch
                class="workexp--switch"
                v-model="current"
                inset
                label="Currently Work Here"
              ></v-switch>
            </v-col>
            <v-col cols="12" :md="current ? '6' : '4'" sm="12" xs="12">
              <v-text-field
                v-if="!current"
                placeholder="Enter To Date"
                persistent-placeholder
                label="To Date"
                v-model="formData.toDate"
                :rules="[rules.required]"
                type="date"
                dense
                color="primary"
                outlined
                prepend-inner-icon="event"
                clearable
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" md="12" sm="12" xs="12">
              <v-textarea
                placeholder="Enter Description"
                persistent-placeholder
                label="Job Description"
                v-model="formData.responsibilitiesDescription"
                :rules="[rules.required]"
                rows="3"
                dense
                color="primary"
                outlined
                prepend-inner-icon="description"
                clearable
              ></v-textarea>
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>
      <v-divider />
      <v-card-actions>
        <v-spacer />
        <v-btn
          class="workexp--button white--text my-3 mr-3"
          color="primary"
          @click="submitWorkExp"
        >
          <v-icon class="mx-3">{{
            $route.query.edit !== undefined ? "edit" : "save"
          }}</v-icon>
          {{ $route.query.edit !== undefined ? "Save" : "Submit" }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-container>
</template>
<script>
import AuthService from "../../../dashboard/modules/auth/AuthService";
import moment from "moment";
export default {
  name: "ExperienceCard",
  components: {},
  data: function () {
    return {
      formData: {
        positionHeld: "",
        nameOfFirm: "",
        fromDate: "",
        toDate: "",
        sector: "",
        responsibilitiesDescription: "",
      },
      current: false,
      isValid: false,
      rules: {
        required: (value) => !!value || "Required.",
      },
    };
  },
  beforeRouteEnter(to, from, next) {
    next((v) => {
      if (to.query.edit !== undefined) {
        v.$store.dispatch("Profile/getexperience", {
          lineNo: to.query.edit.toString(),
        });
      }
    });
  },
  computed: {
    experience() {
      return this.$store.getters["Profile/experienceGetters"]("experience");
    },
    industryGroup() {
      return this.$store.getters["Profile/setupGetter"]("industryGroup");
    },
  },
  watch: {
    current() {
      if (this.current)
        this.formData.toDate = moment(new Date()).format("YYYY-MM-D");
    },
    experience() {
      this.formData = { ...this.experience };
    },
  },
  methods: {
    submitWorkExp() {
      if (!this.isValid) {
        this.$refs.workExpForm.validate();
      } else {
        this.formData.profileID = AuthService.user.profile_id;
        this.$route.query.edit !== undefined
          ? this.$store.dispatch("Profile/editexperience", { ...this.formData })
          : this.$store.dispatch("Profile/submitexperience", {
              ...this.formData,
            });
      }
    },
  },
};
</script>
<style>
@import url("./styles.css");
</style>
